var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.orderServiceItem.type === "hotel"
      ? _c("span", [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("travelService.orderServicesCustomerForm.fromDateHotel")
              ) +
              " "
          ),
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.orderServiceItem.travelServiceOrderItemHotel.start_date
              ) +
                " " +
                _vm._s(
                  _vm.orderServiceItem.travelServiceOrderItemHotel.start_time
                )
            )
          ]),
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("travelService.orderServicesCustomerForm.toDateHotel")
              ) +
              " "
          ),
          _c("b", [
            _vm._v(
              _vm._s(_vm.orderServiceItem.travelServiceOrderItemHotel.end_date)
            )
          ])
        ])
      : _vm._e(),
    _vm.orderServiceItem.type === "flight"
      ? _c("span", [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("travelService.orderServicesCustomerForm.fromDateFlight")
              ) +
              " "
          ),
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.orderServiceItem.travelServiceOrderItemFlight.start_date
              ) +
                " " +
                _vm._s(
                  _vm.orderServiceItem.travelServiceOrderItemFlight.start_time
                )
            )
          ]),
          _vm.orderServiceItem.travelServiceOrderItemFlight.return_date != null
            ? _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "travelService.orderServicesCustomerForm.returnDateFlight"
                      )
                    ) +
                    " "
                ),
                _c("b", [
                  _vm._v(
                    _vm._s(
                      _vm.orderServiceItem.travelServiceOrderItemFlight
                        .return_date
                    ) +
                      " " +
                      _vm._s(
                        _vm.orderServiceItem.travelServiceOrderItemFlight
                          .return_time
                      )
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm.orderServiceItem.type === "rail"
      ? _c("span", [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("travelService.orderServicesCustomerForm.fromDateRail")
              ) +
              " "
          ),
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.orderServiceItem.travelServiceOrderItemRail.start_date
              ) +
                " " +
                _vm._s(
                  _vm.orderServiceItem.travelServiceOrderItemRail.start_time
                )
            )
          ]),
          _vm.orderServiceItem.travelServiceOrderItemRail.return_date != null
            ? _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "travelService.orderServicesCustomerForm.returnDateRail"
                      )
                    ) +
                    " "
                ),
                _c("b", [
                  _vm._v(
                    _vm._s(
                      _vm.orderServiceItem.travelServiceOrderItemRail
                        .return_date
                    ) +
                      " " +
                      _vm._s(
                        _vm.orderServiceItem.travelServiceOrderItemRail
                          .return_time
                      )
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm.orderServiceItem.type === "car"
      ? _c("span", [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("travelService.orderServicesCustomerForm.fromDateCar")
              ) +
              " "
          ),
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.orderServiceItem.travelServiceOrderItemCar.start_date
              ) +
                " " +
                _vm._s(
                  _vm.orderServiceItem.travelServiceOrderItemCar.start_time
                )
            )
          ]),
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("travelService.orderServicesCustomerForm.toDateCar")
              ) +
              " "
          ),
          _c("b", [
            _vm._v(
              _vm._s(_vm.orderServiceItem.travelServiceOrderItemCar.end_date) +
                " " +
                _vm._s(_vm.orderServiceItem.travelServiceOrderItemCar.end_time)
            )
          ])
        ])
      : _vm._e(),
    _vm.orderServiceItem.type === "insurance"
      ? _c("span", [
          _vm._v(" " + _vm._s(_vm.$t("global.startDate")) + " "),
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.orderServiceItem.travelServiceOrderItemInsurance.start_date
              )
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" " + _vm._s(_vm.$t("global.endDate")) + " "),
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.orderServiceItem.travelServiceOrderItemInsurance.end_date
              )
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }